import React from "react";

import {
    FaShoppingCart,
    FaUserPlus,
    FaUsers,
    FaCheckCircle,
    FaClock,
    FaTimesCircle,
    FaRupeeSign,
} from "react-icons/fa";

import MetricCard from "./MetricCard";
import SectionCard from "./SectionCard";

import {
    formatCurrency,
    formatNumber,
} from "../utils/dashboardFormatters";


const WebsiteOverview = ({
    website = {},
}) => {

    const users =
        website?.users ||
        {};

    const orders =
        website?.orders ||
        {};

    const today =
        website?.today ||
        {};


    return (

        <SectionCard
            title="E-Commerce Overview"
            subtitle="Website registrations and customer order activity."
        >

            <div className="dashboard-commerce-layout">

                {/* WEBSITE USERS */}

                <div className="dashboard-commerce-block">

                    <div className="dashboard-subsection-title">

                        <div>
                            <FaUsers />

                            <span>
                                Website Users
                            </span>
                        </div>

                    </div>


                    <div className="dashboard-small-grid">

                        <MetricCard
                            title="Total Users"
                            value={
                                formatNumber(
                                    users?.totalUsers
                                )
                            }
                            icon={FaUsers}
                        />


                        <MetricCard
                            title="New Registrations"
                            value={
                                formatNumber(
                                    users?.newUsers
                                )
                            }
                            icon={FaUserPlus}
                            growth={
                                users?.growthPercentage
                            }
                        />


                        <MetricCard
                            title="Verified Users"
                            value={
                                formatNumber(
                                    users?.verifiedUsers
                                )
                            }
                            icon={FaCheckCircle}
                        />


                        <MetricCard
                            title="Active Users"
                            value={
                                formatNumber(
                                    users?.activeUsers
                                )
                            }
                            icon={FaUsers}
                        />

                    </div>

                </div>


                {/* WEBSITE ORDERS */}

                <div className="dashboard-commerce-block">

                    <div className="dashboard-subsection-title">

                        <div>
                            <FaShoppingCart />

                            <span>
                                Website Orders
                            </span>
                        </div>

                    </div>


                    <div className="dashboard-small-grid">

                        <MetricCard
                            title="Total Orders"
                            value={
                                formatNumber(
                                    orders?.totalOrders
                                )
                            }
                            icon={FaShoppingCart}
                            growth={
                                orders?.growthPercentage
                            }
                        />


                        <MetricCard
                            title="Order Value"
                            value={
                                formatCurrency(
                                    orders?.totalOrderAmount
                                )
                            }
                            icon={FaRupeeSign}
                        />


                        <MetricCard
                            title="Pending Orders"
                            value={
                                formatNumber(
                                    orders?.pendingOrders
                                )
                            }
                            icon={FaClock}
                        />


                        <MetricCard
                            title="Delivered"
                            value={
                                formatNumber(
                                    orders?.deliveredOrders
                                )
                            }
                            icon={FaCheckCircle}
                        />


                        <MetricCard
                            title="Cancelled"
                            value={
                                formatNumber(
                                    orders?.cancelledOrders
                                )
                            }
                            icon={FaTimesCircle}
                        />

                    </div>

                </div>

            </div>


            {/* TODAY WEBSITE SNAPSHOT */}

            <div className="dashboard-commerce-today">

                <div>
                    <span>
                        Today Website Users
                    </span>

                    <strong>
                        {
                            formatNumber(
                                today
                                    ?.users
                                    ?.newUsers
                            )
                        }
                    </strong>
                </div>


                <div>
                    <span>
                        Today Orders
                    </span>

                    <strong>
                        {
                            formatNumber(
                                today
                                    ?.orders
                                    ?.totalOrders
                            )
                        }
                    </strong>
                </div>


                <div>
                    <span>
                        Today Order Value
                    </span>

                    <strong>
                        {
                            formatCurrency(
                                today
                                    ?.orders
                                    ?.totalOrderAmount
                            )
                        }
                    </strong>
                </div>

            </div>

        </SectionCard>

    );
};


export default WebsiteOverview;